<div class="space-y-6 resource-page-container w-[100%]">
  <div class="resource-page-header mb-0 w-[80vw]">
    <h2 class="text-2xl font-semibold">INDEX RESOURCES</h2>
  </div>
  <div class="resource-page-content-wrapper bg-gray-100 border-gray-200 border-t flex justify-center w-[100%]">
    <div class="resource-details-container w-[80vw]">
      <div class="flex items-center justify-between mb-4">
        <h3 class="resource-section-title text-lg font-semibold text-black border-l-4 pl-2 border-green-700">
          Generic Documentation
        </h3>
        <input type="text" placeholder="Search File" [(ngModel)]="searchText"
          class="w-80 pl-4 pr-10 py-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-transparent" />
      </div>

      <div class="mb-2 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 h-80 overflow-y-auto">
        <div *ngFor="let doc of filterDocs()" class="p-2 border-2 border-green-500 h-10 rounded-lg shadow bg-white
              hover:shadow-md transition flex flex-col justify-between">
          <div class="flex items-center justify-between flex-shrink-0 flex-grow-0">
            <h3 class="font-bold text-sm truncate">
              {{ doc.Title }}
            </h3>
            <a href="javascript:void(0)"  (click)="onDownloadDocument(doc)" class="text-white">
              <i *ngIf="doc.FileExtension === 'PDF'" class="pi pi-file-pdf text-xl text-green-500"></i>
              <i *ngIf="
                  doc.FileExtension === 'XLSX' || doc.FileExtension === 'XLS'
                " class="pi pi-file-excel text-xl text-green-500"></i>
              <i *ngIf="doc.FileExtension === 'ZIP'" class="pi pi-file text-xl text-green-500"></i>
              <i *ngIf="doc.FileExtension === 'CSV'" class="pi pi-file text-xl text-green-500"></i>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="flex justify-center w-[100%]">
    <div class="flex w-[80vw] grid-cols-4 text-sm text-gray-800 flex-col">
      <div>
        <div class="flex items-center border-gray-300 pr-4 my-6">
          <h2 class="text-lg font-medium text-black border-l-4 pl-2 border-green-700 pr-2">
            <span class="font-bold">News & Notices</span>
          </h2>
        </div>
        <div class="flex justify-between py-4 align-end items-center mb-6">
          <div class="w-[75%] gap-3 flex align-end items-center mb-1">
            <div class="dropdown-container h-10 w-48">
              <label for="type-dropdown" class="mb-1 font-bold">Type</label>
              <p-dropdown id="type-dropdown" [options]="typeOptions()" [(ngModel)]="filter.type" placeholder="Type"
                (onChange)="setFilters()" class="w-full h-full"></p-dropdown>
            </div>
            <div class="dropdown-container h-10 w-48">
              <label for="publication-date-dropdown" class="mb-1 font-bold">Publication Date</label>
              <p-dropdown id="publication-date-dropdown" [options]="publicationDates"
                [(ngModel)]="filter.publicationDate" placeholder="Publication Date" class="w-full h-full"
                (onChange)="setFilters()"></p-dropdown>
            </div>
            <div class="dropdown-container h-10 w-48">
              <label for="bloomberg-code-dropdown" class="mb-1 font-bold">Bloomberg Code</label>
              <p-dropdown id="bloomberg-code-dropdown" [options]="bloombergCodesOptions()"
                [(ngModel)]="filter.bloombergCode" placeholder="Bloomberg Code" class="w-full h-full"
                (onChange)="setFilters()"></p-dropdown>
            </div>
            <div class="dropdown-container h-10 w-48">
              <label for="event-type-dropdown" class="mb-1 font-bold">Event Type</label>
              <p-dropdown id="event-type-dropdown" [options]="eventTypesOptions()" [(ngModel)]="filter.eventType"
                placeholder="Event Type" class="w-full h-full" (onChange)="setFilters()"></p-dropdown>
            </div>
            <div class="h-10 w-48">
              <label for="reset-button" class="mb-1 invisible">Reset</label>
              <button id="reset-button" pButton type="button" (click)="resetFilter()"
                class="w-full h-full reset-button">
                Reset
              </button>
            </div>
          </div>
        </div>

        <ng-container *ngIf="filteredData">
          <p-table [value]="filteredData" [paginator]="true" [rows]="rows" class="news-and-notices-table"
            [tableStyle]="{ 'min-width': '50rem' }" [sortField]="defaultSortField" [sortOrder]="defaultSortOrder"
            [first]="first" [showCurrentPageReport]="true"
            currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries{{isFilterApplied ? ` (filtered from ${totatlRecordsCount} total entries)` : ''}}"
            stripedRows="">
            <ng-template #header>
              <tr class="bg-bnpp-green text-white">

                <!-- EVENT -->
                <th pSortableColumn="title" style="text-align:left !important; background-position:5% 90%;">
                  EVENT
                  <p-sortIcon field="title"></p-sortIcon>
                </th>

                <!-- TYPE -->
                <th pSortableColumn="newsType">
                  TYPE
                  <p-sortIcon field="newsType"></p-sortIcon>
                </th>

                <!-- PUBLICATION DATE -->
                <th pSortableColumn="publicationDate">
                  PUBLICATION DATE
                  <p-sortIcon field="publicationDate"></p-sortIcon>
                </th>

                <!-- BLOOMBERG CODE -->
                <th pSortableColumn="bloombergCode">
                  BLOOMBERG CODE
                  <p-sortIcon field="bloombergCode"></p-sortIcon>
                </th>

                <!-- EVENT TYPE -->
                <th pSortableColumn="eventType">
                  EVENT TYPE
                  <p-sortIcon field="eventType"></p-sortIcon>
                </th>
              </tr>
            </ng-template>
            <ng-template #body let-news>
              <tr>
                <td [title]="news.title">
                  <i class="pi pi-file-pdf text-sm text-green-500 mr-2"></i>
                  <a href="javascript:void(0)" (click)="onDownloadNewsDocument(news)">{{ news.title }}</a>
                </td>
                <td [title]="news.newsType">{{ news.newsType }}</td>
                <td [title]="news.publicationDate">
                  {{ news.publicationDate }}
                </td>
                <td class="truncate" [title]="news.bloombergCode">
                  {{ news.bloombergCode | slice : 0 : 45
                  }}{{ news.bloombergCode.length > 45 ? '...' : '' }}
                </td>
                <td [title]="news.eventType">{{ news.eventType }}</td>
              </tr>
            </ng-template>
          </p-table>
        </ng-container>
      </div>
    </div>
  </div>
</div>
